import { render, staticRenderFns } from "./OfferingList.vue?vue&type=template&id=67600926&scoped=true&"
import script from "./OfferingList.vue?vue&type=script&lang=js&"
export * from "./OfferingList.vue?vue&type=script&lang=js&"
import style0 from "./OfferingList.vue?vue&type=style&index=0&id=67600926&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67600926",
  null
  
)

export default component.exports